import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  Badge,
  Button
} from "shards-react";

import PageTitle from "../components/common/PageTitle";

class CovidNews extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // First list of posts.
      covidNews: [
        {
          backgroundImage: require("../images/vinit-shahdeo.jpg"),
          category: "DEVELOPER",
          categoryTheme: "dark",
          author: "Vinit Shahdeo",
          authorAvatar: require("../images/avatars/1.jpg"),
          title: "Stay Home, Stay Safe",
          body:
            "Practice Social Distancing and hold on, I am searching news for you :)",
          date: "April 2020"
        }
      ],


      
    };
    this.seeFullNews.bind(this);
  }

  seeFullNews (URL) {
    console.log('Redirecting to ', URL)
    window.open(URL, '_blank');
  }

  componentDidMount() {
    const proxyUrl = "https://cors-anywhere.herokuapp.com/"
    const apiKey = "cf7f3c64d5b24083b7e9db822088fda1";
    const url = `${proxyUrl}https://newsapi.org/v2/top-headlines?country=in&q=COVID&sortBy=popularity&apiKey=${apiKey}&pageSize=9&page=1`;
    const request = new Request(url);
    var index,
      news = [];
    console.log('Fetching news....');
    console.log('Any bugs, feel free to raise an issue on GitHub(@vinitshahdeo)');
    fetch(request)
      .then((res) => res.json())
      .then((data) => {
        for (index = 0; index < data.articles.length; index++) {
          news.push({
            title: data.articles[index].title,
            body: data.articles[index].description,
            source: data.articles[index].source.name,
            url: data.articles[index].url,
            backgroundImage: data.articles[index].urlToImage,
            categoryTheme: "accent"
          });
        }
        this.setState({
          covidNews: news,
        });
      })
      .catch(console.log);
  }

  render() {

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Latest News" subtitle="COVID-19 Tracker | INDIA" className="text-sm-left" />
        </Row>

        {/* First Row of Posts */}
        <Row>
          {this.state.covidNews.map((post, idx) => (
            <Col lg="4" md="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post card-post--1">
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url(${post.backgroundImage})` }}
                >
                  <Badge
                    pill
                    className={`card-post__category bg-${post.categoryTheme}`}
                  >
                    {post.source}
                  </Badge>
                  
                </div>
                <CardBody>
                  <h5 className="card-title">
                    <a href="#" className="text-fiord-blue">
                      {post.title}
                    </a>
                  </h5>
                  <p className="card-text d-inline-block mb-3">{post.body}</p>
                  <span className="text-muted">{post.date}</span>
                  
                </CardBody>
                <CardFooter className="border-top d-flex">
                  <div className="my-auto ml-auto">
                   <a href={post.url} target="_blank">
                    <Button size="sm" theme="white">
                      <i className="fa fa-search-plus mr-1" /> View Full News
                    </Button>
                    </a>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>

        
      </Container>
    );
  }
}

export default CovidNews;
